import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError, Button } from 'common/components/layout';
import { logEvent } from 'common/helpers/analytics';
import {
  getDefaultCountryCode,
  removeSpaces,
  getAmountTenderedByGiftCard
} from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndChargeCart } from 'redux/cart/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';
import { listCustomerCreditCards } from 'redux/customerCreditCards/actions';

import {
  isCreditCardLoggedIn,
  isCreditCardRequired,
  isBillAddressShipLoggedIn,
  isBillAddressPickupLoggedIn,
  isCreditCardNotLoggedIn
} from '../helpers';

import BillAddressPickup from './components/BillAddressPickup';
import BillAddressShip from './components/BillAddressShip';
import CreditCardLoggedIn from './components/CreditCardLoggedIn';
import GiftCards from './components/GiftCards';
import {
  validateAddressForLoggedInCustomer,
  validateAddressForNotLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaveAddress: true,
      isSaveCreditCard: true,
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { props } = this;
    if (props.customer.data) {
      props.listCustomerAddresses();
      props.listCustomerCreditCards();
    }
  }

  successFunction = (order) => {
    const { props } = this;
    const cart = props.cart.data;
    logEvent('Checkout', 'V1 Complete');
    this.setState({ isSubmitting: false });
    let url = `/checkout/receipt?orderNumber=${
      order.orderNumber
    }&email=${encodeURIComponent(cart.email)}`;
    if (props.customer.data) {
      url = `/checkout/receipt/${order.id}`;
    }
    props.history.push(url);
  };

  handleSubmit = async (form) => {
    const { props, state } = this;
    const cart = props.cart.data;
    this.setState({ isSubmitting: true });
    const data = transformData(form, this.props);
    let tender;
    if (isCreditCardRequired(cart)) {
      tender = {
        tenderType: 'Credit Card',
        creditCard: data.creditCard,
        amountTendered: cart.total - getAmountTenderedByGiftCard(cart)
      };
    }
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    let isSaveAddress = false;
    if (isBillAddressShipLoggedIn(cart, props.customer.data)) {
      isSaveAddress =
        form.isSameAsBillingAddress === 'billing' && state.isSaveAddress;
    }
    if (isBillAddressPickupLoggedIn(cart, props.customer.data)) {
      isSaveAddress = state.isSaveAddress;
    }
    let isSaveCreditCard = false;
    if (isCreditCardLoggedIn(cart, props.customer.data)) {
      isSaveCreditCard =
        (!form.customerCreditCardId || form.customerCreditCardId === '') &&
        state.isSaveCreditCard;
    }

    const { executeRecaptcha } = props.googleReCaptchaProps;
    const token = await executeRecaptcha('checkout');
    const recaptchaToken = await executeRecaptcha('checkout');
    const newCreditCardToken = await executeRecaptcha('checkout');

    if (tender) {
      tender.recaptchaToken = recaptchaToken;
    }
    props.updateAndChargeCart(
      data.address,
      tender,
      token,
      newCreditCardToken,
      isSaveAddress,
      isSaveCreditCard,
      this.successFunction,
      errorFunction
    );
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('shipping');
  };

  handleSaveAddress = (e) => {
    this.setState({ isSaveAddress: e.target.checked });
  };

  handleSaveCreditCard = (e) => {
    this.setState({ isSaveCreditCard: e.target.checked });
  };

  render() {
    const { handleSubmit, change, form, settings } = this.props;
    const { customerCreditCards, customer } = this.props;
    const { cart: cartReducer } = this.props;
    const { selectedCreditCardId } = this.props;
    const cart = cartReducer.data;
    const { isSaveAddress, isSaveCreditCard, isSubmitting } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (cart.shipTo) {
      object = cart.shipTo;
    }
    const showCreditCardLoggedIn = isCreditCardLoggedIn(cart, customer.data);
    const showCreditCardNotLoggedIn = isCreditCardNotLoggedIn(
      cart,
      customer.data
    );
    const showShipAddress = cart.orderDeliveryMethod === 'Ship';
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>

        <GiftCards tenders={cart.tenders} settings={settings} />

        {showCreditCardLoggedIn && (
          <CreditCardLoggedIn
            customerCreditCards={customerCreditCards}
            selectedCreditCardId={selectedCreditCardId}
            handleSaveCreditCard={this.handleSaveCreditCard}
            isSaveCreditCard={isSaveCreditCard}
          />
        )}
        {showCreditCardNotLoggedIn && <CreditCardForm />}

        <p>&nbsp;</p>
        <h3>Billing address</h3>
        {showShipAddress && (
          <BillAddressShip
            handleAddressChange={this.handleAddressChange}
            handleSaveAddress={this.handleSaveAddress}
            object={object}
            changeFunction={change}
            isSaveAddress={isSaveAddress}
            customer={customer.data}
          />
        )}
        {!showShipAddress && (
          <BillAddressPickup
            handleAddressChange={this.handleAddressChange}
            handleSaveAddress={this.handleSaveAddress}
            object={object}
            changeFunction={change}
            isSaveAddress={isSaveAddress}
            customer={customer.data}
          />
        )}

        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label="Return to shipping method"
            onClick={this.handleBack}
          >
            Return to shipping method
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let address;
  let creditCard;
  if (props.cart.data.orderDeliveryMethod === 'Ship') {
    if (values.isSameAsBillingAddress === 'billing') {
      address = transformAddressData(values);
      if (isBillAddressShipLoggedIn(props.cart.data, props.customer.data)) {
        address.customerAddressId = values.customerAddressId;
      }
    } else {
      address = props.cart.data.shipTo;
      delete address.id;
    }
  }
  if (props.cart.data.orderDeliveryMethod === 'Pickup') {
    address = transformAddressData(values);
    if (isBillAddressPickupLoggedIn(props.cart.data, props.customer.data)) {
      address.customerAddressId = values.customerAddressId;
    }
  }
  if (isCreditCardLoggedIn(props.cart.data, props.customer.data)) {
    if (!values.customerCreditCardId || values.customerCreditCardId === '') {
      creditCard = {
        cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
        expiryMo: values.expiryMo && integerFormat(values.expiryMo),
        expiryYr: values.expiryYr && integerFormat(values.expiryYr),
        cvv2: values.cvv2,
        cardHolderName: values.cardHolderName
      };
    } else {
      creditCard = {
        customerCreditCardId: values.customerCreditCardId
      };
    }
  }
  if (isCreditCardNotLoggedIn(props.cart.data, props.customer.data)) {
    creditCard = {
      cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
      expiryMo: values.expiryMo && integerFormat(values.expiryMo),
      expiryYr: values.expiryYr && integerFormat(values.expiryYr),
      cvv2: values.cvv2,
      cardHolderName: values.cardHolderName
    };
  }
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  if (props.cart.data.orderDeliveryMethod === 'Ship') {
    if (values.isSameAsBillingAddress === 'billing') {
      const { address } = transformData(values, props);
      address.birthDay =
        values.birthDay && convertStringToInteger(values.birthDay);
      address.birthMonth =
        values.birthMonth && convertStringToInteger(values.birthMonth);
      address.birthYear =
        values.birthYear && convertStringToInteger(values.birthYear);
      if (isBillAddressShipLoggedIn(props.cart.data, props.customer.data)) {
        errors = Object.assign(
          errors,
          validateAddressForLoggedInCustomer(address, props.settings)
        );
      } else {
        errors = Object.assign(
          errors,
          validateAddressForNotLoggedInCustomer(address, props.settings)
        );
      }
    }
  }
  if (props.cart.data.orderDeliveryMethod === 'Pickup') {
    const { address } = transformData(values, props);
    address.birthDay =
      values.birthDay && convertStringToInteger(values.birthDay);
    address.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    address.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    if (isBillAddressPickupLoggedIn(props.cart.data, props.customer.data)) {
      errors = Object.assign(
        errors,
        validateAddressForLoggedInCustomer(address, props.settings)
      );
    } else {
      errors = Object.assign(
        errors,
        validateAddressForNotLoggedInCustomer(address, props.settings)
      );
    }
  }
  if (isCreditCardLoggedIn(props.cart.data, props.customer.data)) {
    if (!values.customerCreditCardId || values.customerCreditCardId === '') {
      const { creditCard } = transformData(values, props);
      errors = Object.assign(errors, validateCreditCard(creditCard));
    }
  }
  if (isCreditCardNotLoggedIn(props.cart.data, props.customer.data)) {
    const { creditCard } = transformData(values, props);
    errors = Object.assign(errors, validateCreditCard(creditCard));
  }
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  let selectedCreditCardId;
  if (state.cart && state.cart.data) {
    const { billTo } = state.cart.data;
    initialValues = initialFormValues(billTo);
    initialValues.isSameAsBillingAddress = 'shipping';
    if (!initialValues.countryCode) {
      initialValues.countryCode = getDefaultCountryCode(state.setting);
    }
    const { tenders } = state.cart.data;
    if (tenders.length > 0) {
      const { creditCard } = tenders[0];
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      selectedCreditCardId = creditCard.customerCreditCardId;
    }
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues,
    selectedCreditCardId
  };
};

Payment = reduxForm({
  form: 'paymentLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withGoogleReCaptcha(
  withRouter(
    connect(mapStateToProps, {
      updateAndChargeCart,
      listCustomerCreditCards,
      listCustomerAddresses
    })(Payment)
  )
);
